import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import BarGraphs from '../../components/Charts/BarGraphs'
import PieChart from '../../components/Charts/PieChart'
import Select from 'react-select'

import HomeLarge from '../../components/HomeLarge';
import HomeMini from '../../components/HomeMini';

import CustomHeader from '../../components/Header'
import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'
import BasicTable from '../../components/Tables/BasicTable'
import axiosConfig from '../../config/axiosConfig'


const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? 'yellow' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: 'Yellow'

    })
}

function Iframe(props) {

    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}

class SuspiciousFleetBulletIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            ViewDropDownOptionsNEW: [
                { value: 'No', label: 'ST(No)' },
                { value: 'PKR', label: 'ST(PKR)' }
            ],
            timeFrameDropDownOptions: [
                { value: '1', label: 'Last 3 months' },
                { value: '2', label: 'Last 6 months' },
                { value: '3', label: 'Last 12 months' }
            ],


            BulletInOption: '',
            BulletInGroup: '',
            BulletInsearchCriteria: 'vrn',
            BulletInVRNGroupMultiID: '',
            BulletTimeFrame: 'three_month',

            srcURL_SuspiciousBulletin: '',

            SelectChartView3: 'No',

            //reportBaseURL: 'http://localhost:40383/Charts?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Charts?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',
            VRNMappingMasterId: '',
        };

        this.BulletInOptionChange = this.BulletInOptionChange.bind(this)
        this.BulletInVehicleChange = this.BulletInVehicleChange.bind(this)
        this.BulletInGroupChange = this.BulletInGroupChange.bind(this)

        this.changeOptionTime = this.changeOptionTime.bind(this)
        this.ViewOption3 = this.ViewOption3.bind(this)
    }

    componentDidMount() {

        this.getTabularData();

    }

    async changeOptionTime(selectedOption) {
        await this.setState({ TimeFrameId: selectedOption.value })
    }

    async BulletInOptionChange(selectedOption) {
        if (selectedOption == 1) {
            await this.setState({ BulletInsearchCriteria: "vrn" })
            this.getTabularData();
        }
        else
            await this.setState({ BulletInOption: selectedOption, BulletInGroup: 0 })
    }

    async BulletInVehicleChange(selectedVehicle) {


        // await this.setState({ Vehicle: selectedVehicle, Group: 0 })

    }

    async BulletInGroupChange(selectedGroup) {

        await this.setState({ BulletInsearchCriteria: "vrngroup", BulletInVRNGroupMultiID: selectedGroup })
        this.getTabularData();

    }

    async ViewOption3(selectedView) {

        console.log('ViewOption3');

        if (selectedView.value === "No")
            await this.setState({ SelectChartView3: "No" })
        else
            await this.setState({ SelectChartView3: "PKR" })

        this.getTabularData()
    }

    /* End of Tabular Data */

    async getTabularData() {
        let DateRange = this.state.BulletTimeFrame;
        // this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "SuspeciousTransMinAvgMaxTrend";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=' + this.state.SelectChartView3 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.BulletInsearchCriteria == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=' + this.state.SelectChartView3 + '&VRNGroupingID=' + this.state.BulletInVRNGroupMultiID + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_SuspiciousBulletin: ReportFullURL })
    }

    render() {

        return (

            <div>
                <CustomHeader />

                <Container>
                    {/* 
                    <Card>
                        <Card.Body> */}
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Suspicious Transactions Bulletin</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptions}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime}
                                                    defaultValue={{ label: "Last 3 months", value: 1 }}
                                                    isDisabled={true}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose View</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.ViewDropDownOptionsNEW}
                                                    styles={customStyles}
                                                    onChange={this.ViewOption3}
                                                    defaultValue={{ label: "ST(No)", value: "No" }}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">
                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    onOptionChange={this.BulletInOptionChange}
                                                    onGroupChange={this.BulletInGroupChange}
                                                    onVehicleChange={this.BulletInVehicleChange} />
                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-xl-12 col-lg-12 col-md-12 p-0 pr-2">
                                            <Card>
                                                <Card.Body className="p-0">
                                                    <Iframe src={this.state.srcURL_SuspiciousBulletin} height="430" width="1250" />

                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </Row>

                                </Card.Body>
                            </Card>


                        </Col>

                    </Row>
                
                
                
                </Container>
            </div >
        );
    }
}

export default SuspiciousFleetBulletIn;